import { render, staticRenderFns } from "./changeScrCode.vue?vue&type=template&id=13ec5684&scoped=true&lang=pug"
import script from "./changeScrCode.vue?vue&type=script&lang=js"
export * from "./changeScrCode.vue?vue&type=script&lang=js"
import style0 from "./changeScrCode.vue?vue&type=style&index=0&id=13ec5684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec5684",
  null
  
)

export default component.exports